<template>
  <div>
    <button-print-screen />
    <nav-title :color="false" :title="'skills learned'" />
    <section class="container px-lg-5 pt-3">
      <div class="d-flex align-items-center">
        <h5 class="text-center text-darked flex-grow-1 mb-0 ml-4 mr-sm-1 mr-md-0 pl-5">
          {{ getSkillDescription.text }}
        </h5>
        <custom-button router :to="{name: 'PlanRate', params: { Mid: $route.params.Mid }}" class="px-4 py-1">
          Quiz
        </custom-button>
      </div>
      <div class="d-flex align-items-center justify-content-between p-2 bg-light my-3 border">
        <p class="small text-muted">
          Have you learned this skill?
        </p>
        <b-form-checkbox v-model="checked" name="check-button" @change="sendState" switch>
          <span v-if="checked" class="small">
            Yes
          </span>
          <span v-else class="small">
            Not yet
          </span>
        </b-form-checkbox>
      </div>
      <div v-html="getSkillDescription.description" class="full-size-img"></div>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import navTitle from '@/components/general/navTitle.vue';
import { ButtonPrintScreen } from '@/components/general/buttons';
import CustomButton from '@/components/general/CustomButton.vue';

export default {
  components: {
    navTitle,
    ButtonPrintScreen,
    CustomButton,
  },
  data() {
    return {
      checked: this.$route.query.state,
    };
  },
  methods: {
    ...mapActions('planning', ['updateLearnSkillState']),
    sendState() {
      this.updateLearnSkillState({
        parent: this.getUserId,
        skill: this.$route.params.Mid,
        learn_completed: !this.checked,
      });
    },
  },
  computed: {
    ...mapGetters('planning', ['getSkillDescription', 'getSkillName']),
    ...mapGetters('user', ['getUserId']),
  },
  beforeRouteEnter(to, from, next) {
    let skill = to.params.Mid;
    Promise.all([
      store.dispatch('planning/FetchSkillDescription', skill),
      store.dispatch('planning/FetchSkillName', skill),
    ]).then(() => {
      next();
    });
  },
};
</script>
<style lang="scss">
.full-size-img img {
  width: 100% !important;
}
.print-screen {
  bottom: 20px;
}
</style>
